const SET_BREADCRUMB = 'alerts/SET_BREADCRUMB';

export {
  SET_BREADCRUMB
};